import type { IAccountPayableBill } from "@apis/accounts/types"
import { RewardCheckItem } from "./RewardCheckItem"

type TRewardChecksListProps = { account_payable_bills: IAccountPayableBill[] }

export const RewardChecksList = ({
  account_payable_bills,
}: TRewardChecksListProps) => {
  return (
    <div>
      {account_payable_bills.map((bill) => (
        <RewardCheckItem
          key={bill.account_payable_bill_id}
          payable_bill={bill}
        />
      ))}
    </div>
  )
}
